class MobileSizeBar3dids extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-open]');
    this.details = this.closest('.product-details') || document;

    if (this.hasAttribute('data-single-3dids')) {
      this.setState('chosen');
      return;
    }

    this.setState('closed');

    this.button?.addEventListener('click', () => this.setState(this.dataset.state === 'open' ? 'closed' : 'open'));

    this.details.addEventListener('change', (event) => {
      if (event.target instanceof HTMLInputElement && event.target.closest('variant-picker')) this.setState('chosen');
    });

    document.addEventListener('click', (event) => {
      if (this.dataset.state !== 'open') return;
      const target = event.target;
      if (target instanceof Element && (this.contains(target) || target.closest('variant-picker, .buy-buttons-block'))) return;
      this.setState('closed');
    });
  }

  setState(state) {
    this.dataset.state = state;
    this.button?.setAttribute('aria-expanded', String(state === 'open'));
  }
}

if (!customElements.get('mobile-size-bar-3dids')) {
  customElements.define('mobile-size-bar-3dids', MobileSizeBar3dids);
}
